import './style.scss';
import { mapStyles } from './map-styles';

export function location_details_block() {
    const block = document.querySelector('.location_details_block');
    if (!block) return;


    const tabs = block.querySelectorAll(".location-tab");
    const panels = block.querySelectorAll(".location-panel");

    const maps = {}; // store map by index

    const markerSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
<path d="M11.8117 36.6164C5.28828 30.093 5.2883 19.5164 11.8117 12.993L12.9929 11.8118C19.5164 5.28832 30.0929 5.28833 36.6164 11.8118L37.7976 12.993C44.321 19.5164 44.321 30.093 37.7976 36.6164L27.167 47.247C25.8623 48.5517 23.747 48.5517 22.4423 47.247L11.8117 36.6164Z" fill="#EC7B72"/>
<path d="M23.4492 28.1978C23.6251 28.1978 23.7674 28.3403 23.7676 28.5161V34.6655C23.7675 34.8414 23.6251 34.9839 23.4492 34.9839H19.9629C18.0892 34.9838 16.5706 33.4649 16.5703 31.5913C16.5703 29.7175 18.0891 28.1979 19.9629 28.1978H17.0762C16.9002 28.1978 16.7568 28.0553 16.7568 27.8794V21.73C16.7571 21.5543 16.9004 21.4116 17.0762 21.4116H19.9629C18.0891 21.4116 16.5706 19.8927 16.5703 18.019C16.5703 16.1451 18.089 14.6255 19.9629 14.6255H32.7207C32.8965 14.6256 33.0389 14.7681 33.0391 14.9438V21.0933C33.039 21.2691 32.8965 21.4115 32.7207 21.4116H28.9463C30.8202 21.4117 32.3389 22.9313 32.3389 24.8052C32.3387 26.6789 30.8201 28.1977 28.9463 28.1978H23.4492Z" fill="white"/>
</svg>`;



    const allLocationsMapEl = block.querySelector('.all-locations-map');
    let allMapInstance = null;
    let allMapInitialized = false;
    let allMapBounds = null;

    function initAllMap() {
        if (!allLocationsMapEl || allMapInitialized) return;
        if (!window.google || !window.google.maps) return;

        allMapBounds = new google.maps.LatLngBounds();
        const locations = [];
        panels.forEach(panel => {
            const lat = parseFloat(panel.dataset.lat);
            const lng = parseFloat(panel.dataset.lng);
            if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
                const loc = { lat, lng };
                locations.push(loc);
                allMapBounds.extend(loc);
            }
        });

        if (locations.length === 0) return;

        allMapInstance = new google.maps.Map(allLocationsMapEl, {
            center: allMapBounds.getCenter(),
            zoom: 14,
            disableDefaultUI: true,
            styles: mapStyles,
            gestureHandling: 'none',
            keyboardShortcuts: false,
        });

        const icon = {
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(markerSvg),
            scaledSize: new google.maps.Size(40, 54)
        };

        locations.forEach(loc => {
            new google.maps.Marker({
                position: loc,
                map: allMapInstance,
                icon: icon
            });
        });

        allMapInstance.fitBounds(allMapBounds);
        allMapInitialized = true;
    }


    function setMarkerToLeft(map, lat, lng, panel) {
        if (!map) return;

        // If mobile/tablet, just center normally
        if (window.innerWidth < 1280) {
            map.setCenter({ lat, lng });
            return;
        }

        const mapEl = panel.querySelector('.location-map');
        if (!mapEl) return;

        const projection = map.getProjection();
        // If projection not ready, we can't calculate exact latlng yet.
        // Fallback to center first, or wait.
        if (!projection) {
            map.setCenter({ lat, lng });
            return;
        }

        const offset = mapEl.offsetWidth / 4; // We want marker at 25% from left (so center is +25% right)

        const scale = Math.pow(2, map.getZoom());
        const centerPoint = projection.fromLatLngToPoint(new google.maps.LatLng(lat, lng));

        // We shift the center to the RIGHT (positive X in standard projection)
        // so the marker appears on the LEFT.
        const newCenterPoint = new google.maps.Point(
            centerPoint.x - (offset / scale), // Note: fromLatLngToPoint x usually increases right. But let's verify direction.
            // If center X decreases (moves left), map moves right -> Marker moves right.
            // We want marker left. So Center must be right.
            // Center X should INCREASE. 
            // Wait, (0,0) is top left. 
            // Center X + Offset = Right.
            // So we should ADD offset?
            // Google Maps Projection: x increases to Right.
            // We want Center to be to the Right of Marker.
            // So Center.x > Marker.x
            // So we ADD.
            centerPoint.y
        );

        // Wait, let's verify PanBy behavior again.
        // panBy(x, y): "x positive: Center moves Left" (Map image moves Right).
        // If I PanBy(-offset, 0) (Negative), Center moves Right. Map moves Left. Marker moves Left.
        // So I want PanBy(-offset, 0).
        // PanBy(-offset) means Center Pixel increases?
        // Let's rely on panBy logic inversely.
        // CENTER = MARKER + OFFSET (in pixels).
        // PROJ_CENTER = PROJ_MARKER + (OFFSET / SCALE).

        const finalCenterPoint = new google.maps.Point(
            centerPoint.x + (offset / scale),
            centerPoint.y
        );

        const newCenterLatLng = projection.fromPointToLatLng(finalCenterPoint);
        map.setCenter(newCenterLatLng);
    }

    function initMap(panel, id) {
        if (maps[id]) return; // already initialized

        const mapEl = panel.querySelector('.location-map');
        if (!mapEl) return;

        const lat = parseFloat(mapEl.dataset.lat) || -27.522993;
        const lng = parseFloat(mapEl.dataset.lng) || 153.192703;

        if (Number.isNaN(lat) || Number.isNaN(lng)) {
            console.warn('Invalid coords for map', id);
            return;
        }

        const icon = {
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(markerSvg),
            scaledSize: new google.maps.Size(40, 54)
        };

        const map = new google.maps.Map(mapEl, {
            center: { lat, lng },
            zoom: 14,
            disableDefaultUI: true,
            styles: mapStyles,
        });

        new google.maps.Marker({
            position: { lat, lng },
            map,
            icon: icon,
        });

        maps[id] = map;

        // Adjust center once map is ready (projection available)
        google.maps.event.addListenerOnce(map, 'projection_changed', () => {
            setMarkerToLeft(map, lat, lng, panel);
        });
    }

    function getInitialTabFromURL() {
        const params = new URLSearchParams(window.location.search);
        const slug = params.get('loc');
        if (!slug) return null;

        return block.querySelector(
            `.location-tab[data-slug="${slug}"]`
        );
    }


    const tabFromURL = getInitialTabFromURL();
    const initialTab = tabFromURL || tabs[0];
    if (!initialTab) return;

    const forceInitialClick = () => {
        if (window.google && window.google.maps) {
            setTimeout(() => {
                if (initialTab.classList.contains('active')) {
                    // Manually init the active tab's map without clicking (which would toggle it off)
                    const id = initialTab.dataset.loc;
                    const panel = block.querySelector(`.location-panel[data-panel="${id}"]`);
                    if (panel) {
                        initMap(panel, id);
                        // Ensure default map is hidden
                        if (allLocationsMapEl) allLocationsMapEl.style.display = 'none';

                        // Force adjustment if map already existed
                        if (maps[id]) {
                            const lat = parseFloat(panel.dataset.lat);
                            const lng = parseFloat(panel.dataset.lng);
                            setMarkerToLeft(maps[id], lat, lng, panel);
                        }
                    }
                } else {
                    initialTab.click();
                }

                if (tabFromURL) {
                    block.scrollIntoView({ behavior: 'smooth', block: 'start', });
                }
            }, 100);
        }
    };

    forceInitialClick();




    tabs.forEach((tab) => {

        tab.addEventListener("click", () => {
            const id = tab.dataset.loc;
            const isActive = tab.classList.contains("active");

            // Deactivate all
            tabs.forEach(t => t.classList.remove("active"));
            panels.forEach(p => p.classList.remove("active"));

            // If it was already active, we are deactivating it -> Show Default Map
            if (isActive) {
                if (allLocationsMapEl) {
                    allLocationsMapEl.style.display = 'block';
                    if (!allMapInitialized) {
                        // Try to init if not ready
                        initAllMap();
                    } else {
                        // Resize trigger
                        // Use requestAnimationFrame to ensure style change (display:block) is applied
                        requestAnimationFrame(() => {
                            google.maps.event.trigger(allMapInstance, 'resize');
                            // Wait another frame for map to handle resize?
                            requestAnimationFrame(() => {
                                if (allMapBounds) {
                                    allMapInstance.fitBounds(allMapBounds);
                                }
                            });
                        });
                    }
                }
                return;
            }

            // Otherwise, activate this one
            tab.classList.add("active");
            if (allLocationsMapEl) allLocationsMapEl.style.display = 'none';

            const matchedPanels = block.querySelectorAll(`.location-panel[data-panel="${id}"]`);

            matchedPanels.forEach(panel => {
                panel.classList.add("active");
                initMap(panel, id);
                //force resize (required)
                if (maps[id]) {
                    google.maps.event.trigger(maps[id], 'resize');
                    const lat = parseFloat(panel.dataset.lat);
                    const lng = parseFloat(panel.dataset.lng);
                    setMarkerToLeft(maps[id], lat, lng, panel);


                }

                panel.classList.add("animating");

                setTimeout(() => {
                    panel.classList.remove("animating");
                }, 450);

            }
            );



        });
    });

    // Try to init all map on load (if google is ready, or wait for click)
    const tryInitAllMap = () => {
        if (window.google && window.google.maps) {
            initAllMap();
        } else {
            setTimeout(tryInitAllMap, 500);
        }
    };
    tryInitAllMap();



}

